
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skigebied",
      function () {
        return require("private-next-pages/[region]/[resort]/skigebied.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skigebied"])
      });
    }
  